import HeroRosterDispatcher from '~/flux/dispatchers/HeroRosterDispatcher';

const HeroRosterActions = {
  dismissHero({ heroHandle }: { heroHandle: string }) {
    HeroRosterDispatcher.handleHeroRosterAction({
      actionType: HeroRosterDispatcher.DISMISS_HERO,
      heroHandle,
    });
  },
};
export default HeroRosterActions;
